export default "__VITE_ASSET__CeTOaYOe__"